import React from 'react';
import { font, radius, tone as tones, Tone, weight } from '../theme';
import { stageInfo } from '../utils/stages';

interface BadgeProps {
  children: React.ReactNode;
  tone?: Tone;
  // 'tag': small rounded rectangle (stages, types); 'pill': rounded chip for facts (מושב 107)
  shape?: 'tag' | 'pill';
  // Optional colored dot before the text, e.g. a party color
  dot?: string;
  style?: React.CSSProperties;
}

// A non-interactive status label. Never use it as a button.
export const Badge = ({ children, tone = 'neutral', shape = 'tag', dot, style }: BadgeProps) => {
  const t = tones[tone];
  const pill = shape === 'pill';
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      maxWidth: '100%',
      minWidth: 0,
      boxSizing: 'border-box',
      fontSize: pill ? font.small : font.caption,
      fontWeight: weight.medium,
      lineHeight: 1.4,
      padding: pill ? '3px 10px' : '2px 8px',
      borderRadius: pill ? radius.pill : radius.sm,
      background: t.bg,
      color: t.fg,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {dot && <span style={{ width: 8, height: 8, borderRadius: '50%', background: dot, flexShrink: 0 }} />}
      {/* One line; a label wider than its container ends in an ellipsis */}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>{children}</span>
    </span>
  );
};

// A bill's simpleStage in its stage tone
export const StageBadge = ({ stage, style }: { stage: string | undefined; style?: React.CSSProperties }) => (
  <Badge tone={stageInfo(stage).tone} style={style}>{stage || 'אחר'}</Badge>
);

export default Badge;
